import React from 'react';
import Navbar from '../components/nav/Navbar';
import Footer from '../components/nav/Footer';
import { Link } from 'react-router-dom';

const ForArtists = () => {
  return (
    <div className="min-h-screen flex flex-col bg-zinc-950 text-zinc-100">
      <Navbar />
      <main className="flex-1 max-w-4xl mx-auto w-full px-8 py-24 space-y-12 relative z-10">
        <div className="space-y-4">
          <span className="text-xs font-black tracking-widest text-brand-pink uppercase">Creators</span>
          <h1 className="text-5xl font-black tracking-tighter text-white uppercase">For Artists</h1>
        </div>
        
        <div className="space-y-8 text-zinc-300 text-lg leading-relaxed">
          <p className="text-2xl font-bold text-white">
            Take control of your music career and build a sustainable income directly from your biggest fans.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
            <div className="glass-card p-8 rounded-2xl space-y-4">
              <h2 className="text-xl font-black text-brand-pink uppercase tracking-tight">Direct Sales</h2>
              <p className="text-base text-zinc-400">
                Sell your music, merchandise, and exclusive content directly to your audience. Keep a larger share of the revenue compared to traditional streaming platforms.
              </p>
            </div>

            <div className="glass-card p-8 rounded-2xl space-y-4">
              <h2 className="text-xl font-black text-lime-400 uppercase tracking-tight">Subscriptions</h2>
              <p className="text-base text-zinc-400">
                Create custom membership tiers to offer ongoing value to your super fans. Provide early access, exclusive tracks, and behind-the-scenes content.
              </p>
            </div>

            <div className="glass-card p-8 rounded-2xl space-y-4">
              <h2 className="text-xl font-black text-brand-coral uppercase tracking-tight">Analytics</h2>
              <p className="text-base text-zinc-400">
                Get deep insights into your audience, track sales performance, and understand what content resonates best with your fan base.
              </p>
            </div>

            <div className="glass-card p-8 rounded-2xl space-y-4">
              <h2 className="text-xl font-black text-white uppercase tracking-tight">Community</h2>
              <p className="text-base text-zinc-400">
                Foster a closer relationship with your listeners. Engage with your supporters in a dedicated, distraction-free environment.
              </p>
            </div>
          </div>

          <div className="pt-8 text-center">
            <Link to="/auth" className="inline-block px-8 py-4 bg-white text-black font-black uppercase tracking-widest rounded-full hover:bg-brand-pink hover:text-white transition-colors">
              Apply as an Artist
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ForArtists;